import declensionByNum from 'src/utils/declensionByNum'
import { POPULAR_ANALYSIS_PARTNER_SLUG }
  from 'src/components/pages/[town-translit]/diagnostika/analiz/_constants/analyses-popular'
import type { PopularAnalysisCard } from 'src/components/pages/[town-translit]/diagnostika/analiz/components/types'
import type { PopularAnalysisContextItem } from 'src/components/pages/[town-translit]/diagnostika/analiz/_types'

const formatDuration = (executionDays: number): string => {
  if (!executionDays) {
    return ''
  }

  return `от ${executionDays} ${declensionByNum(executionDays, ['дня', 'дней', 'дней'])}`
}

const getPopularAnalysisHref = (townTranslit: string, analysisName: string): string => {
  const search = new URLSearchParams({ analysis: analysisName })

  return `/${townTranslit}/analyses/${POPULAR_ANALYSIS_PARTNER_SLUG}/?${search.toString()}`
}

const mapPopularAnalysis = (
  item: PopularAnalysisContextItem,
  townTranslit: string,
): PopularAnalysisCard => ({
  id: `${item.analysis_synonym_id}${item.biomaterial_id}`,
  name: item.name,
  href: getPopularAnalysisHref(townTranslit, item.name),
  price: item.price_with_discount,
  oldPrice: item.price,
  duration: formatDuration(item.execution_days),
  biomaterial: item.biomaterial_name,
})

export default mapPopularAnalysis
